import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  InAppBrowser,
  InAppBrowserOptions,
} from "@ionic-native/in-app-browser/ngx";
import { AlertController, LoadingController } from "@ionic/angular";
import { STORAGE } from "src/app/constant/storages";
import { ApiserviceService } from "../../../httpservice/apiservice.service";
import { AppService } from "../../../services/app.service";
import { TEXT } from "../../../text_control";
import { errMsg } from "../../../text_control/error-msg";
import { BTN } from "../../../text_control/text_button";
import { TEXT_TABLE } from "../../../text_control/text_table";
import { _getStorage, _setStorage } from "../../../utils/local-storage";

@Component({
  selector: "app-preview-no-taxinvoice",
  templateUrl: "./preview-no-taxinvoice.component.html",
  styleUrls: ["./preview-no-taxinvoice.component.scss"],
})
export class PreviewNoTaxinvoiceComponent implements OnInit {
  sub: any = [];
  browser: InAppBrowser;
  dataAddress: any;
  dataitem: any;
  showbtn = false;
  text: any = {};
  textBTN: any = {};
  textTB: any = {};

  options: InAppBrowserOptions = {
    location: "yes", //Or 'no'
    hideurlbar: "yes",
    navigationbuttoncolor: "white",
    toolbarcolor: "red",
    toolbarposition: "top",
    closebuttoncaption: "CLOSE",
    closebuttoncolor: "white",
    hidden: "no", //Or  'yes'
    clearcache: "yes",
    clearsessioncache: "yes",
    zoom: "yes", //Android only ,shows browser zoom controls
    hardwareback: "yes",
    mediaPlaybackRequiresUserAction: "no",
    shouldPauseOnSuspend: "no", //Android only
    disallowoverscroll: "no", //iOS only
    toolbar: "yes", //iOS only
    enableViewportScale: "no", //iOS only
    allowInlineMediaPlayback: "no", //iOS only
    presentationstyle: "pagesheet", //iOS only
    fullscreen: "yes", //Windows only
  };

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";
  headerNewService: any;

  constructor(
    private route: ActivatedRoute,
    private iab: InAppBrowser,
    public appService: AppService,
    public apiservice: ApiserviceService,
    public alertController: AlertController,
    public loadingController: LoadingController
  ) {
    this.userID = _getStorage(STORAGE.userID)
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);
    this.text = TEXT;
    this.textBTN = BTN;
    this.textTB = TEXT_TABLE;
  }
  ionViewDidEnter() {
    this.appService.setActive(5);
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params.newService === "NEW_SERVICE") {
        this.headerNewService = params.newService;
      }
    });

    this.sub = _getStorage(STORAGE.DATA_PREVIEW_NO__TAXINVOICE)
    this.sub.forEach((i) => {
      i["isDownload"] = false;
    });
  }

  openbrowser(data) {
    let target = "_self";
  }

  async getPDF(item) {
    let target = "_self";
    const req_load_pdf = {
      taxno: item.new_taxinvoice_no,
      storebu: this.userBu,
      storeid: this.userLoc,
      userBu: this.userBu,
      userLoc: this.userLoc,
      userRole: this.userRole,
      userSource: this.userSource,
      user_id: this.userID,
      mtrans_id: item.mtrans_id,
    };


    console.log("======== req load pdf =======: ", req_load_pdf);
    try {
      this.apiservice
        ._post(this.apiservice.apiUrl + this.apiservice.getNewPDF, req_load_pdf)
        .then((res) => {
          console.log("======== res load pdf =======: ", res);
          if (res.statusCode === 200) {
            const browser = this.iab.create(res.data, target, this.options);
            this.showbtn = true;
            item.isDownload = true;
          } else {
            this.ErrorMsg(res.statusMessage);
          }
        });
    } catch (error) {
      // this.ErrorMsg(errMsg.error);
    }
  }

  async confirmABB(item, receiptNo) {
    let header: any;

    if (this.headerNewService) {
      header = {
        "rtsnewservice": "rts-new-service"
      }
    }
    await this.apiservice
      ._post(
        this.apiservice.apiUrl + this.apiservice.confirmCreate,
        item.request,
        header
      )
      .then((res) => {
        console.log("res confirm ======:", res);
        try {
          if (res.statusCode === 200) {
            let setRes = res.data;
            const index = this.sub.findIndex((f) => f.receiptNo === receiptNo);
            if (index > -1) {
              for (const item of setRes) {
                this.sub[index] = {
                  ...item.data,
                  status: true,
                  message: "สำเร็จ",
                };
              }
              _setStorage(STORAGE.DATA_PREVIEW_NO__TAXINVOICE, this.sub);

              window.location.reload();
            }
          } else {
            this.ErrorMsg(res.statusMessage);
          }
        } catch (error) {
          this.ErrorMsg(errMsg.error);
        }
      });
  }


  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }
  checkaddress(data) {
    if (data.type_addr === "1") {
      return data.addr_info;
    } else if (data.type_addr === "2") {
      return data.addr_infoEN;
    } else {
      return "-";
    }
  }

  checkbranch(data: any) {
    // console.log("[-------data branch------]", data);
    if (data.buyer_type === "0") {
      return "-";
    } else if (data.buyer_type === "1") {
      if (data.buyer_main_branch_no === "00000") {
        return "สำนักงานใหญ่";
      } else {
        return data.buyer_branch_no;
      }
    } else if (data.buyer_type === "2") {
      return "-";
    } else {
      return "-";
    }
  }
}
